const TIKTOK_INSTANT_PAGE_SDK_SRC =
  "https://sf-unpkg.tiktokcdn.com/obj/unpkg-va/latest/byted/instant_page_sdk/dist/index.js";

let instantPageReady = null;

const loadInstantPageSdk = (appId) => {
  if (instantPageReady) return instantPageReady;

  instantPageReady = new Promise((resolve, reject) => {
    window.InstantPageAsyncInit = () => {
      if (!window.InstantPage?.__buzzlyInitialized) {
        window.InstantPage.init({
          appId,
          version: "v1.0",
        });
        window.InstantPage.__buzzlyInitialized = true;
      }
      resolve(window.InstantPage);
    };

    if (window.InstantPage) {
      window.InstantPageAsyncInit();
      return;
    }

    const existing = document.querySelector(
      'script[data-tiktok-instant-page="true"]'
    );
    const script = existing || document.createElement("script");
    script.onload = () => {
      if (window.InstantPage && !window.InstantPage.__buzzlyInitialized) {
        window.InstantPageAsyncInit();
      }
    };
    script.onerror = () => {
      instantPageReady = null;
      reject(new Error("TikTok Instant Page SDK failed to load"));
    };
    if (!existing) {
      script.src = TIKTOK_INSTANT_PAGE_SDK_SRC;
      script.async = true;
      script.dataset.tiktokInstantPage = "true";
      document.body.appendChild(script);
    }
  });

  return instantPageReady;
};

export const getTikTokInstantPageLanguage = (language) =>
  String(language || "")
    .toLowerCase()
    .startsWith("es")
    ? "es"
    : "en";

const isPopupBlocked = (popup) => {
  if (!popup) return true;
  try {
    return popup.closed === true;
  } catch {
    return false;
  }
};

const closeEditorPopup = (popup) => {
  if (!popup) return;
  try {
    popup.close();
  } catch {
    return;
  }
};

export const openTikTokInstantPageEditor = async ({
  appId,
  advertiserId,
  tipSdkAccessToken,
  language,
}) => {
  if (!appId || !advertiserId || !tipSdkAccessToken) {
    throw new Error("Missing Instant Page editor parameters");
  }

  const InstantPage = await loadInstantPageSdk(appId);

  return new Promise((resolve, reject) => {
    const originalOpen = window.open.bind(window);
    let editorPopup = null;

    const restoreOpen = () => {
      if (window.open !== originalOpen) {
        window.open = originalOpen;
      }
    };

    const restoreTimeoutId = setTimeout(restoreOpen, 1000);

    window.open = (...args) => {
      const popup = originalOpen(...args);
      clearTimeout(restoreTimeoutId);
      restoreOpen();
      if (!editorPopup) {
        editorPopup = popup;
        if (isPopupBlocked(popup)) {
          const error = new Error("popup-blocked");
          error.code = "popupBlocked";
          reject(error);
        }
      }
      return popup;
    };

    try {
      InstantPage.start(
        {
          accountId: String(advertiserId),
          appId,
          ixAccessToken: tipSdkAccessToken,
          businessType: 1,
          display: "popup",
          actionType: "create",
          language: getTikTokInstantPageLanguage(language),
        },
        (response) => {
          const pageId = response?.pageId || response?.page_id;
          if (!pageId) return;
          closeEditorPopup(editorPopup);
          resolve({
            id: String(pageId),
            status: response.status,
          });
        }
      );
    } catch (error) {
      restoreOpen();
      reject(error);
    }
  });
};
